<template>
  <b-container v-if="this.type" fluid>
    <h1>{{title || $appConfig.models[this.type].title}} <b-button v-if="$appConfig.models[this.type].allowNew" variant="secondary" size="sm" v-b-modal.modalEventForm v-translate>+ NEW</b-button></h1>
    <b-card no-body class="filters">
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('Quick Filters')" active>
          <b-card-text>
            <b-row>
              <b-col class="text-center filter-actions">
                <b-badge size="md" @click="resetQuickFilters" v-translate>Reset Filters</b-badge> <b-badge size="sm" @click="saveCurrentQuickFilters" v-translate>Save this Filters' Set</b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" md="2">
                <b-form-group>
                  <label for="filter-roles" v-translate>Area</label>
                  <b-form-select v-model="filter.areaId" :options="areasSelect">
                    <template slot="first">
                      <option :value="null" v-translate>All Areas</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <div class="form-group">
                  <label for="filter-user-id" v-translate>Date Range</label>
                  <b-form-select v-model="filter.current">
                    <option :value="true" v-translate>Current/Future</option>
                    <option :value="false" v-translate>Past</option>
                  </b-form-select>
                </div>
              </b-col>
              <b-col>
                <div class="form-group">
                  <label for="filter-name" v-translate>Active</label>
                  <b-form-select v-model="filter.active">
                    <option :value="null" v-translate>Both</option>
                    <option :value="1" v-translate>Active</option>
                    <option :value="false" v-translate>Inactive</option>
                  </b-form-select>
                </div>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <label for="filter-roles" v-translate>Event Type</label>
                  <b-form-select v-model="filter.eventTypeId" :options="eventTypesSelect">
                    <template slot="first">
                      <option :value="null" v-translate>All Types</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Advanced Filters')">
          <b-card-text>
            <b-row>
              <b-col lg="12" class="my-1">
                <listing-filter :type="type" @save-filter="saveCurrentAdvancedFilters" :filter-fields="filterFields" :pre-filters="preFilters" @refresh="refreshTable" ref="listingFilters" />
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Saved Filters')" :disabled="savedEventsQuickSearches.length === 0">
          <b-list-group>
            <b-list-group-item v-for="(savedQuickSearch, index) in savedEventsQuickSearches" :key="index" :href="savedQuickSearch.url" class="d-flex justify-content-between align-items-center">
              {{ savedQuickSearch.name }}
              <b-badge href="#" @click.stop.prevent="deleteSavedQuickSearch(index)" variant="danger">✕</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row class="mb-3">
      <b-col>

      </b-col>
      <b-col cols="12" sm="3" lg="2">
        <b-form-group horizontal :label="$gettext('Per page')" :label-cols="6" class="text-right mb-0">
          <b-form-select  cols="6" :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="bg-white py-1" v-translate="{totalRows: totalRows || '-'}">
        Total items: <strong>%{totalRows}</strong>
      </b-col>
    </b-row>
    <b-table show-empty :empty-text="'There are no ' + $appConfig.models[this.type].title + ' to show'" id="my-table" stacked="md" foot-clone :total-rows="totalRows" :sort-desc="sortDesc" :sort-by="sortBy" :per-page="perPage" :current-page="currentPage" :busy.sync="isBusy" :items="myProvider" :fields="fields" :api-url="this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint" :filter="applyFilter">

      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong v-translate>Loading...</strong>
      </div>

      <template v-slot:cell(id)="data">
        <a :href="'/edit/' + type + '/' + data.value" v-b-modal.modalEventForm @click.prevent="Object.assign(eventEdit, data.item)">{{data.value | uuid }}</a></template>

      <template v-slot:cell(area_id)="row">
        {{ row.item.area.name }}
      </template>

      <template v-slot:cell(event_type_id)="row">
        {{ row.item.event_type.name }}
      </template>

      <template v-slot:cell(amount)="row">
        {{row.value + ' ' + (row.item.amount_type === 'percentage' ? '%' : row.item.area.currency)}}
      </template>

      <template v-slot:cell(active)="row" class="text-center">
        <span :title="row.item.active ? $gettext('Enabled') : $gettext('Disabled')" style="display: inline-block; width:15px; height:15px; border-radius: 100px;" :class="row.item.active ? 'bg-success' : 'bg-danger'"></span>
      </template>

      <template v-slot:cell(from_date)="row">
        {{moment.utc(row.item.from_date).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.from_date).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(to_date)="row">
        {{moment.utc(row.item.to_date).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.to_date).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(actions)="row">
        <b-button pill size="sm" @click.stop="row.toggleDetails" style="padding: .5rem">
          <font-awesome-icon v-if="row.detailsShowing" :icon="['far', 'eye-slash']" size="2x" style="font-size: 16px;vertical-align: middle" />
          <font-awesome-icon v-else :icon="['far', 'eye']" size="2x" style="font-size: 16px;vertical-align: middle" />
        </b-button>
        <b-button pill size="sm" :variant="row.item.active ? 'danger' : 'success'" @click.stop="deactivateEvent(row.item)" style="padding: .5rem .6rem">
          <font-awesome-icon v-if="row.item.active" icon="stop" size="2x" style="font-size: 20px;vertical-align: middle" />
          <font-awesome-icon v-else icon="play" size="2x" style="font-size: 20px;vertical-align: middle" />
        </b-button>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key" v-if="value && value.length !== 0 && value !== 'undefined' && value !== null">{{ key }}: <span v-html="key.indexOf('phone') === -1 ? isJson(value) : value.toString()"></span></li>
          </ul>
        </b-card>
      </template>

    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" v-if="totalRows > perPage" class="my-0" />

    <b-modal id="modalEventForm" ref="modalEventForm" size="md" :hide-footer="true" @hide="resetEventEdit(); updateQuickFilters()">
      <div slot="modal-title">
        <span v-if="eventEdit.id" v-translate>Edit Event</span>
        <span v-else v-translate>New Event</span>
      </div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <event-create :event="eventEdit || false" />
    </b-modal>
  </b-container>
</template>

<script>
function initialQuickFilters() {
  return {
    areaId: null,
    current: true,
    active: 1,
    eventTypeId: null
  }
}

import ListingFilter from '@/components/ListingFilter'
import EventCreate from '@/components/EventCreate'

export default {
  name: 'EventsList',
  components: {
    ListingFilter,
    EventCreate
  },
  props: {
    type: {
      type: String,
      default: 'events'
    },
    title: {
      type: String
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 25
    }
  },
  data () {
    return {
      tabIndex: 0,
      fields: [],
      filterFields: this.$appConfig.models[this.type].filters,
      exclude: this.$appConfig.models[this.type].exclude,
      includes: this.$appConfig.models[this.type].includes || [],
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [ 10, 25, 50, 100, 500 ],
      sortBy: 'updated_at',
      sortDesc: true,
      sortDirection: 'desc',
      filters: this.preFilters,
      filter: initialQuickFilters(),
      quickFilters: {},
      savedEventsQuickSearches: [],
      eventEdit: {
        id: null,
        area_id: null,
        event_type_id: null,
        amount: '',
        amount_type: null,
        from_date: this.moment().utc(),
        to_date: this.moment().utc(),
        active: true
      }
    }
  },
  watch: {
    type: function (val) {
      this.resetData()
      this.$refs.listingFilters.resetData()
      this.fields = this.$appConfig.models[this.type].fields
      this.filterFields = this.$appConfig.models[this.type].filters
      this.exclude = this.$appConfig.models[this.type].exclude
      this.fields.push({ key: 'actions', label: this.$gettext('Actions') })
      let that = this
      this.fields = this.fields.filter(function (obj) {
        if (that.exclude) {
          return that.exclude.indexOf(obj.key) === -1
        } else {
          return true
        }
      })
    },
    exclude: function (val) {
      return this.$appConfig.models[this.type].exclude
    },
    'filter.areaId': {
      handler (val) {
        if (val !== null) {
          this.quickFilters['areaId'] = [ 'area_id', 'eq', val ]
        } else {
          this.quickFilters['areaId'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.current': {
      handler (val) {
        if (val) {
          this.quickFilters['current'] = [ 'to_date', 'gte', this.moment.utc().format('YYYY-MM-DD HH:mm:ss') ]
        } else {
          this.quickFilters['current'] = [ 'to_date', 'lte', this.moment.utc().format('YYYY-MM-DD HH:mm:ss') ]
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.active': {
      handler (val) {
        if (val !== null) {
          this.quickFilters['active'] = [ 'active', 'eq', val ]
        } else {
          this.quickFilters['active'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.eventTypeId': {
      handler (val) {
        if (val !== null) {
          this.quickFilters['eventTypeId'] = [ 'event_type_id', 'eq', val ]
        } else {
          this.quickFilters['eventTypeId'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    }
  },
  computed: {
    returnAreas() {
      return this.areasSelect.map(x => { return x.value }) // .join(',')
    },
    applyFilter () {
      return this.filter
    }
  },
  created() {
    this.fetchAreas()
      .then(() => {
        if (!this.$cookies.get('bypassCountry')) {
          this.quickFilters['country'] = ['area.country', 'eq', window.country]
          this.updateQuickFilters()
        }
        this.fetchEventTypes()
      })
    window.addEventListener('popstate', () => {
      if (this.$route.query.s) {
        this.tabIndex = 1
        this.checkAdvancedFilters()
      } else if (this.$route.query.qs) {
        this.tabIndex = 0
        this.checkQuickFilters()
      }
    })
  },
  mounted() {
    this.resetData()
    this.fields = this.$appConfig.models[this.type].fields
    this.includes = this.$appConfig.models[this.type].includes
    this.exclude = this.$appConfig.models[this.type].exclude
    let that = this
    let fields = this.fields.filter(function (obj) {
      if (that.exclude) {
        return that.exclude.indexOf(obj.key) === -1
      } else {
        return true
      }
    })
    fields.push({ key: 'actions', label: this.$gettext('Actions') })
    this.fields = fields
    if (this.$route.query.s) {
      this.tabIndex = 1
      this.checkAdvancedFilters()
    } else if (this.$route.query.qs) {
      this.checkQuickFilters()
    } else {
      this.refreshTable()
    }
    if (localStorage.savedEventsQuickSearches) {
      this.savedEventsQuickSearches = JSON.parse(localStorage.savedEventsQuickSearches)
    }
  },
  methods: {
    checkAdvancedFilters() {
      // this.quickFilters = []
      if (this.$route.query.s) {
        this.advancedFilters = JSON.parse(this.$route.query.s)
        this.$refs.listingFilters.filters = this.advancedFilters
        console.log(this.advancedFilters)
      }
      this.refreshTable(this.advancedFilters)
    },
    checkQuickFilters() {
      this.advancedFilters = []
      this.$refs.listingFilters.resetData()
      if (this.$route.query.qs) {
        this.quickFilters = JSON.parse(this.$route.query.qs)
        Object.keys(JSON.parse(this.$route.query.qs)).forEach(function (key) {
          if (this.quickFilters[key].length > 2) {
            this.filter[key] = this.quickFilters[key][2]
          } else if (this.quickFilters[key].length === 2) {
            this.filter[key] = []
            for (let i = 0; i < this.quickFilters[key][0][2].length; i++) {
              this.filter[key].push({id: this.quickFilters[key][0][2][i], name: this.quickFilters[key][1][i], email: this.quickFilters[key][1][i]})
            }
          }
        }.bind(this))
        this.updateQuickFilters()
      }
    },
    updateQuickFilters() {
      if (this.tabIndex === 0) {
        this.currentPage = 1
        let filters = []
        Object.values(this.quickFilters).forEach(function (filter) {
          if (filter.length === 2) {
            filters.push(filter[0])
          } else {
            filters.push(filter)
          }
        })
        if (filters.length > 0) {
          this.$router.push({ query: {qs: JSON.stringify(this.quickFilters)} })
        }
        this.refreshTable(filters)
      }
    },
    resetQuickFilters: function () {
      Object.assign(this.$data.filter, initialQuickFilters())
      this.updateQuickFilters()
    },
    saveCurrentQuickFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedEventsQuickSearches.push({name: 'QUICK: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedEventsQuickSearches = JSON.stringify(this.savedEventsQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedEventsQuickSearches = JSON.parse(localStorage.savedEventsQuickSearches)
    },
    resetAdvancedFilters: function () {
      this.$refs.listingFilters.resetData()
      this.$refs.listingFilters.emitRefresh()
    },
    saveCurrentAdvancedFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedEventsQuickSearches.push({name: 'ADVANCED: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedEventsQuickSearches = JSON.stringify(this.savedEventsQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedEventsQuickSearches = JSON.parse(localStorage.savedEventsQuickSearches)
    },
    deleteSavedQuickSearch(index) {
      this.savedEventsQuickSearches.splice(index, 1)
      localStorage.savedEventsQuickSearches = JSON.stringify(this.savedEventsQuickSearches)
      this.savedEventsQuickSearches = JSON.parse(localStorage.savedEventsQuickSearches)
    },
    myProvider (ctx) {
      console.log(ctx)
      let params = {
        page: ctx.currentPage - 1,
        limit: ctx.perPage,
        includes: this.includes,
        sort: [
          {
            key: ctx.sortBy || 'id',
            direction: ctx.sortDesc ? 'desc' : 'asc'
          }
        ]
      }
      console.log(this.filters)
      if (this.filters || this.preFilters) {
        params.filter_groups = [
          {
            filters: this.filters || this.preFilters
          }
        ]
      }
      console.log(JSON.stringify(params))

      let promise = this.$http.get(ctx.apiUrl, { params: params })

      return promise.then((data) => {
        const items = data.body.data
        // // Here we could override the busy state, setting isBusy to false
        // // this.isBusy = false
        this.totalRows = data.body.pagination.total
        return (items)
      }).catch(error => {
        console.log(error)
        // Here we could override the busy state, setting isBusy to false
        // this.isBusy = false
        // Returning an empty array, allows table to correctly handle busy state in case of error
        return []
      })
    },
    refreshTable (filters) {
      console.log(filters)
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', 'my-table')
      }, 100)
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    resetEventEdit() {
      Object.assign(this.$data.eventEdit, this.$options.data.call(this).eventEdit)
    },
    deactivateEvent(item) {
      let status = !item.active
      this.$http.patch(this.$appConfig.api.baseUrl + 'events/' + item.id, {active: status})
        .then(response => {
          this.resetEventEdit()
          this.updateQuickFilters()
        })
    }
  }
}
</script>
